import { render, staticRenderFns } from "./Cascader2.vue?vue&type=template&id=0279613d&scoped=true"
import script from "./Cascader2.vue?vue&type=script&lang=js"
export * from "./Cascader2.vue?vue&type=script&lang=js"
import style0 from "./Cascader2.vue?vue&type=style&index=0&id=0279613d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0279613d",
  null
  
)

export default component.exports